import comp from "./CurrentRating";
export default comp;
